import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  rgrnService,
  WorkOrderService
} from "../../../services/index";
import { SaleDC } from "../../../services/salesDc.service";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditRgrn.html",
})
export class addEditRgrn {
  row: any;
  data: any;
  designdata: any = {};
  acdata: any = {
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    totalmtr: 0,
    totalamt: 0,
  };
  qualityList: any;
  typeList: any;
  box: boolean;
  shirt: boolean;
  colorList: any;
  codeList: any;
  widthList: any[];
  box_print: string;
  onsaveDisable : boolean = false;
  noofpcs: number;
  res1: any;
  export: boolean = false;
  setShow: boolean = false;
  isNewDesign: any = 'false';
  setmasterData: any[]
  fullsetData: any[];
  halfsetData: any[];
  TotData : any = {
    fullsetTot : 0,
    fullsizeTot:0,
    fullTot: 0,
    halfsetTot: 0,
    halfsizeTot: 0,
    halfTot: 0,
    fullsetNos: 0,
    halfsetNos: 0
  };
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  printPreview = [];
  designPreview = [];
  tempData = [];
  shadeList: any = [];
  canTot = 0;
  balDiff: any;
  // rgrnList = [{
  //     shade: '',
  //     meter: 0,
  //     f36: 0,
  //     f38: 0,
  //     f40: 0,
  //     f42: 0,
  //     f44: 0,
  //     h36: 0,
  //     h38: 0,
  //     h40: 0,
  //     h42: 0,
  //     h44: 0,
  //     totmtrs: 0
  // }];
  rgrnList = [
    {
      shirt_design_no: "",
      shade: "",
      rf36: 0,
      rf38: 0,
      rf40: 0,
      rf42: 0,
      rf44: 0,
      rf46: 0,
      rh36: 0,
      rh38: 0,
      rh40: 0,
      rh42: 0,
      rh44: 0,
      rh46: 0,
      rfdif: 0,
      rhdif: 0,
      rtotmtrs: 0,
      rbalmtrs: 0,
    },
  ];
  designList = [
    {
      design_no: "",
      dshade: "",
      dcolor: "",
      df36: 0,
      df38: 0,
      df40: 0,
      df42: 0,
      df44: 0,
      df46: 0,
      dh36: 0,
      dh38: 0,
      dh40: 0,
      dh42: 0,
      dh44: 0,
      dh46: 0,
      dftot: 0,
      dhtot: 0,
      dfs_total: 0,
      dhs_total: 0,
    },
  ];
  mode: string;
  saveEvent: any;
  agentList: any;
  cancelList = [
    {
      shade: "",
      color: "",
      slv: "",
      size: "",
      qty: "",
    },
  ];
  partyCodeList: any;
  isLoading: boolean = false;
  checked: boolean = true;
  isLoadMask: Promise<any>;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.acdata = designdata;

    if (this.mode == "Edit" || this.mode == "View") {
      this.isNewDesign = designdata.isNewDesign
    
      this.acdata.ac_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.getpartyname(this.acdata.party_code);
      this.acdata.wsp_full = designdata.wsp_full;
      this.acdata.wsp_half = designdata.wsp_half;
      this.getrgrnList(this.acdata.rgrn_id);
   
  
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private saleDC: SaleDC,
    private woservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private rgrnService: rgrnService
  ) {}
  ngOnInit() {
    this.calcdGrandTotal();

    if (this.mode == "Add") {
      this.acdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.acdata.party_code = "UNIT 1";
      this.getpartyname(this.acdata.party_code);
      this.getAuto();
      this.getsetDet()
    }
    this.tableScroll();
  }

  tableScroll() {
    $(".acbody").height(window.innerHeight - 600);
    $(".acbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#wono").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToNextFld1($event, fld, ind) {
    let nxtInd = ind,
      shade = this.rgrnList[ind]["shade"],
      // meter = this.rgrnList[ind]['meter'],
      // fper = this.rgrnList[ind]['fper'],
      // hper = this.rgrnList[ind]['hper'];
      f36 = this.rgrnList[ind].rf36,
      f38 = this.rgrnList[ind].rf38,
      f40 = this.rgrnList[ind].rf40,
      f42 = this.rgrnList[ind].rf42,
      f44 = this.rgrnList[ind].rf44,
      h36 = this.rgrnList[ind].rh36,
      h38 = this.rgrnList[ind].rh38,
      h40 = this.rgrnList[ind].rh40,
      h42 = this.rgrnList[ind].rh42,
      h44 = this.rgrnList[ind].rh44;
    //   balmtrs = this.rgrnList[ind].fbalmtrs,
    //   totmtrs = this.rgrnList[ind]['totmtrs'];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.rgrnList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "dshade" && nxtRow.length == 0) {
      let len = this.rgrnList.length;
      let shade = this.rgrnList[len - 1]["shade"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.rgrnList.push({
          shirt_design_no: "",
          shade: "",
          rf36: 0,
          rf38: 0,
          rf40: 0,
          rf42: 0,
          rf44: 0,
          rf46: 0,
          rh36: 0,
          rh38: 0,
          rh40: 0,
          rh42: 0,
          rh44: 0,
          rh46: 0,
          rfdif: 0,
          rhdif: 0,
          rtotmtrs: 0,
          rbalmtrs: 0,
        });

        $("#" + "dshade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
      /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
            fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
            $('#'  + fld + '-' + nxtInd).select();
           
        }else if(fld=="f36"){
            nxtInd = nxtInd +1;
             $('#'  + fld + '-' + nxtInd).select();
        }
        else if (fld == "item_name") {
            let nxtRowID = nxtRow[0].id;
            nxtInd = nxtRowID.split("-")[1];
        } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  checkTotDiff(){
    this.canTot = 0;
    this.cancelList.forEach(el => {
      this.canTot += Number(el.qty) || 0
    });
    
    //For Handling Save Flag
    this.onsaveDisable = this.acdata.tot_dif > 0 && (this.acdata.tot_dif !=  ((this.acdata.dtot_pcs || 0) + this.canTot))
        
  }

  setpcsTot() {
    // Reset TotData values
    Object.assign(this.TotData, {
      halfTot: 0,
      fullTot: 0,
      fullsizeTot: 0,
      fullsetTot: 0,
      halfsetTot: 0,
      halfsizeTot: 0,
      fullsetNos: 0,
      halfsetNos: 0
    });
    let uniqueIdsFull = [];
    let uniqueIdsHalf = [];

    this.TotData.fullTot = this.fullsetData.reduce((sum, e) => sum + (Number(e.rftot) || 0), 0);
    this.TotData.halfTot = this.halfsetData.reduce((sum, e) => sum + (Number(e.rhtot) || 0), 0);


    // this.fullsetData.forEach(e => );

    this.fullsetData.forEach(e => {
      e.fullset_size.includes('SIZE') ? this.TotData.fullsizeTot++ : this.TotData.fullsetTot++;

      if (e.fullset_id && !uniqueIdsFull.includes(e.fullset_id)) {
        uniqueIdsFull.push(e.fullset_id); // Add to tracking list
        this.TotData.fullsetNos++; // Increment count
      }
    });


    this.halfsetData.forEach(e => {
      e.halfset_size.includes('SIZE') ? this.TotData.halfsizeTot++ : this.TotData.halfsetTot++

      if (e.halfset_id && !uniqueIdsHalf.includes(e.halfset_id)) {
        uniqueIdsHalf.push(e.halfset_id); // Add to tracking list
        this.TotData.halfsetNos++; // Increment count
      }
    });

  this.fullsetData = this.applyBalanceAndSplit(this.rgrnList, this.fullsetData, 'rftot', 'rftot');
this.halfsetData = this.applyBalanceAndSplit(this.rgrnList, this.halfsetData, 'rhtot', 'rhtot');


  }


//   applyBalanceAndSplit(sourceList, targetList, key, totalKey) {
// console.log(sourceList, targetList, key, totalKey, "check set Funstionssssssss")
//   const totalByShade = {};
//   sourceList.forEach(item => {
//     totalByShade[item.shade] = item[totalKey] || 0;
//   });

//   const balanceByShade = {};
//   const updatedList = [];

//   let lastShade = null;
//   let currentInd = 1;
//   for (const item of targetList) {
//     const shade = item.shade;
//     if (!shade) {
//       updatedList.push(item);
//       continue;
//     }

//     // Insert dummy row before shade change
//     if (lastShade !== null && lastShade !== shade) {
//       updatedList.push({ new_qty: 0 });
//       currentInd = 1;
//     }
//     lastShade = shade;

//     // Handle balance logic
//     const newItem = { ...item };

//     newItem.currentInd = currentInd++;

//     if (!(shade in balanceByShade)) {
//       const total = totalByShade[shade] || 0;
//       newItem.bal_qty = total;
//       balanceByShade[shade] = total - (newItem[key] || 0);
//     } else {
//       newItem.bal_qty = balanceByShade[shade];
//       balanceByShade[shade] -= (newItem[key] || 0);
//     }

//     updatedList.push(newItem);
//   }



//   return updatedList;
// }

applyBalanceAndSplit(sourceList, targetList, key, totalKey) {


  const totalByShade = {};
  sourceList.forEach(item => {
    totalByShade[item.shade] = item[totalKey] || 0;
  });

  const balanceByShade = {};
  const updatedList = [];

  let lastShade = null;
  let currentInd = 1;
  let prevBalQty = 0; // track previous bal_qty to calculate dummy row value

  for (const item of targetList) {
    const shade = item.shade;
    if (!shade) {
      updatedList.push(item);
      continue;
    }

    // Insert dummy row before shade change, but use calculated new_qty
    if (lastShade !== null && lastShade !== shade) {
      // new_qty = prevBalQty - last item's key value for last shade
      const lastItem = updatedList[updatedList.length - 1];
      const dummyQty = prevBalQty - (lastItem[key] || 0);

      updatedList.push({ new_qty: 0, bal_qty: dummyQty });
      currentInd = 1;
    }
    lastShade = shade;

    // Handle balance logic
    const newItem = { ...item };
    newItem.currentInd = currentInd++;

    if (!(shade in balanceByShade)) {
      const total = totalByShade[shade] || 0;
      newItem.bal_qty = total;
      balanceByShade[shade] = total - (newItem[key] || 0);
    } else {
      newItem.bal_qty = balanceByShade[shade];
      balanceByShade[shade] -= (newItem[key] || 0);
    }

    prevBalQty = newItem.bal_qty; // update prevBalQty after balance calc

    updatedList.push(newItem);
  }

  // Add dummy row after the last index of the array for the last shade
  if (updatedList.length > 0) {
    const lastItem = updatedList[updatedList.length - 1];
    if (lastItem.shade) {
      const dummyQty = prevBalQty - (lastItem[key] || 0);
      updatedList.push({ new_qty: 0, bal_qty: dummyQty  });
    }
  }
 console.log(updatedList)
  return updatedList;
}



  addCancelDetails(ind) {
    let len = this.cancelList.length;
    this.cancelList[len] = this.cancelList[ind];
    this.cancelList[0] = {
      shade: "",
      color: "",
      slv: "",
      size: "",
      qty: "",
    };
    $("#" + "shade3" + "-" + 0).focus();

  
  }
  getcolor1(shirtdno, shade, ind) {
    let params = {
      shirtdno: shirtdno,
      shade: shade,
    };
    this.rgrnService.getcolor(params).then((res: any) => {
      this.cancelList[ind].color = res.data[0].color;
    });
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;

    // shade = this.rgrnList[ind]['shade'],
    // meter = this.rgrnList[ind]['meter'],
    // fper = this.rgrnList[ind]['fper'],
    // hper = this.rgrnList[ind]['hper'];
    /*  f36 = this.designList[ind].f36,
         f38 = this.designList[ind].f38,
         f40 = this.designList[ind].f40,
         f42 = this.designList[ind].f42,
         f44 = this.designList[ind].f44,
         h36 = this.designList[ind].h36,
         h38 = this.designList[ind].h38,
         h40 = this.designList[ind].h40,
         h42 = this.designList[ind].h42,
         h44 = this.designList[ind].h44, */
    //   balmtrs = this.designList[ind].fbalmtrs,
    //   totmtrs = this.designList[ind]['totmtrs'];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.designList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "dshade" && nxtRow.length == 0) {
      let len = this.designList.length;
      let shade = this.designList[len - 1]["dshade"];

      nxtInd = nxtInd + 1;
      $("#" + "dshade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.designList.push({
          design_no: "",
          dshade: "",
          dcolor: "",
          df36: 0,
          df38: 0,
          df40: 0,
          df42: 0,
          df44: 0,
          df46: 0,
          dh36: 0,
          dh38: 0,
          dh40: 0,
          dh42: 0,
          dh44: 0,
          dh46: 0,
          dftot: 0,
          dhtot: 0,
          dfs_total: 0,
          dhs_total: 0,
        });

        $("#" + "dshade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
      /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
            fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
            $('#'  + fld + '-' + nxtInd).select();
           
        }else if(fld=="f36"){
            nxtInd = nxtInd +1;
             $('#'  + fld + '-' + nxtInd).select();
        }
        else if (fld == "item_name") {
            let nxtRowID = nxtRow[0].id;
            nxtInd = nxtRowID.split("-")[1];
        } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  // onGoToNextFld($event, fld, ind) {
  //     let nxtInd = ind,

  //         f36 = this.designList[ind].df36,
  //         f38 = this.designList[ind].df38,
  //         f40 = this.designList[ind].df40,
  //         f42 = this.designList[ind].df42,
  //         f44 = this.designList[ind].df44,
  //         h36 = this.designList[ind].dh36,
  //         h38 = this.designList[ind].dh38,
  //         h40 = this.designList[ind].dh40,
  //         h42 = this.designList[ind].dh42,
  //         h44 = this.designList[ind].dh44,

  //         totmtrs = this.designList[ind]['totmtrs'];

  //     let nxtRow = $('#row-' + ind).next('tr');
  //     if (fld == "shade" && nxtRow.length == 0) {
  //         let len = this.designList.length;
  //         let shade = this.designList[len - 1]['shade'];

  //         nxtInd = nxtInd + 1;
  //         $('#' + 'shade' + '-' + nxtInd).focus();

  //         if (shade != '' && nxtInd == len) {

  //             this.designList.push({
  //                 design_no: '',
  //                 dshade: '',
  //                 dcolor:'',
  //                 df36: 0,
  //                 df38: 0,
  //                 df40: 0,
  //                 df42: 0,
  //                 df44: 0,
  //                 df46:0,
  //                 dh36: 0,
  //                 dh38: 0,
  //                 dh40: 0,
  //                 dh42: 0,
  //                 dh44: 0,
  //                 dh46: 0,
  //                 dftot:0,
  //                 dhtot:0,
  //                 dfs_total: 0,
  //                 dhs_total: 0

  //             });

  //             $( 'dshade' + '-' + nxtInd).focus();

  //         } else if (shade == '' && nxtInd == len) {
  //             let a = nxtInd - 1;
  //             $('#' + 'dshade' + '-' + a).focus();
  //         }
  //         else {

  //             $('#' + 'dshade' + '-' + nxtInd).focus();

  //             return false;

  //         }

  //     }
  //     else if (fld == "df36" || fld == "df38" || fld == "df40" || fld == "df42" || fld == "df44") {
  //         $('#' + fld + '-' + nxtInd).select();
  //     } else if (fld == "dh36" || fld == "dh38" || fld == "dh40" || fld == "dh42" || fld == "dh44") {
  //         $('#' + fld + '-' + nxtInd).select();
  //     }
  //     else if (fld == "item_name") {
  //         let nxtRowID = nxtRow[0].id;
  //         nxtInd = nxtRowID.split("-")[1];
  //     } else {

  //         setTimeout(() => {
  //             $('#' + fld + '-' + nxtInd).focus();
  //         }, 100);

  //     }
  // }

  onSelectShade(shade, ind) {
    let params = {
      fab_design_no: this.acdata.fab_design_no,
      color: shade,
    };
    let that = this;
    that.woservice.getStock(params).then((res: any) => {
      if (res.data.length > 0) {
        //         this.stockdata = res.data;
      } else {
        this.designList[ind]["mtr"] = "";
        this.designList[ind]["fs_tot_cons"] = 0;
        this.designList[ind]["hs_tot_cons"] = 0;
        this.designList[ind]["fs_tot_pcs"] = 0;
        this.designList[ind]["hs_tot_pcs"] = 0;
        this.designList[ind]["f36"] = 0;
        this.designList[ind]["f38"] = 0;
        this.designList[ind]["f40"] = 0;
        this.designList[ind]["f42"] = 0;
        this.designList[ind]["f44"] = 0;
        this.designList[ind]["f46"] = 0;
        this.designList[ind]["h36"] = 0;
        this.designList[ind]["h38"] = 0;
        this.designList[ind]["h40"] = 0;
        this.designList[ind]["h42"] = 0;
        this.designList[ind]["h44"] = 0;
        this.designList[ind]["h46"] = 0;
        //         this.calcBalMtrs(ind);
      }
      // this.designList[ind]['mtr']=this.stockdata[0]['avl_mtrs'];
      // this.woCalc(ind);
    });
  }

  // calcTotal($event,ind){
  //     let item = this.designList[ind];

  //     let totalmtrs = item.rf36+ item.rf38 + item.rf40 + item.rf42 +item.rf44
  //      + item.rh36 + item.rh38 + item.rh40 + item.rh42 + item.rh44;
  //     this.designList[ind]['rftot'] =  item.rf36+ item.rf38 + item.rf40 + item.rf42 +item.rf44;
  //     this.designList[ind]['rhtot'] = item.rh36 + item.rh38 + item.rh40 + item.rh42 + item.rh44;
  //     this.designList[ind].rtotmtrs = parseFloat(totalmtrs.toFixed(3));

  //         this.calcRate();

  // }

  calcTotal(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    for (let i = 0; i < this.rgrnList.length; i++) {
      //ftotalpcs
      this.rgrnList[ind]["rftot"] =
        nan(this.rgrnList[ind]["rf36"]) +
        nan(this.rgrnList[ind]["rf38"]) +
        nan(this.rgrnList[ind]["rf40"]) +
        nan(this.rgrnList[ind]["rf42"]) +
        nan(this.rgrnList[ind]["rf44"]) +
        nan(this.rgrnList[ind]["rf46"]);

      //htotalpcs
      this.rgrnList[ind]["rhtot"] =
        nan(this.rgrnList[ind]["rh36"]) +
        nan(this.rgrnList[ind]["rh38"]) +
        nan(this.rgrnList[ind]["rh40"]) +
        nan(this.rgrnList[ind]["rh42"]) +
        nan(this.rgrnList[ind]["rh44"]) +
        nan(this.rgrnList[ind]["rh46"]);

      //calccons
      this.rgrnList[ind]["ravg_cons"] = (
        nan(this.rgrnList[ind]["mtr"]) /
        (nan(this.rgrnList[ind]["rftot"]) + nan(this.rgrnList[ind]["rhtot"]))
      ).toFixed(2);
      //  this.rgrnList[ind]['rhavg_cons']= (nan(this.rgrnList[ind]['mtr'])/(nan(this.rgrnList[ind]['rftot'])+nan(this.rgrnList[ind]['rhtot']))).toFixed(2);

      //calcdiff
      this.rgrnList[ind]["rfdif"] =
        nan(this.rgrnList[ind]["ftot"]) - nan(this.rgrnList[ind]["rftot"]);
      this.rgrnList[ind]["rhdif"] =
        nan(this.rgrnList[ind]["htot"]) - nan(this.rgrnList[ind]["rhtot"]);
    }
    // for (let i = 0; i < this.designList.length; i++) {
    //     //ftotalpcs
    //     this.designList[ind]['dftot'] = nan(this.designList[ind]['df36']) + nan(this.designList[ind]['df38']) + nan(this.designList[ind]['df40']) + nan(this.designList[ind]['df42']) + nan(this.designList[ind]['df44']) + nan(this.designList[ind]['df46']);

    //     //htotalpcs
    //     this.designList[ind]['dhtot'] = nan(this.designList[ind]['dh36']) + nan(this.designList[ind]['dh38']) + nan(this.designList[ind]['dh40']) + nan(this.designList[ind]['dh42']) + nan(this.designList[ind]['dh44']) + nan(this.designList[ind]['dh46']);

    //     //calccons
    //     // this.designList[ind]['ravg_cons'] = (nan(this.designList[ind]['mtr']) / (nan(this.designList[ind]['rftot']) + nan(this.designList[ind]['rhtot']))).toFixed(2);
    //     //  this.designList[ind]['rhavg_cons']= (nan(this.designList[ind]['mtr'])/(nan(this.designList[ind]['rftot'])+nan(this.designList[ind]['rhtot']))).toFixed(2);

    //     //calcdiff
    //     this.designList[ind]['rfdif'] = nan(this.designList[ind]['ftot']) - nan(this.designList[ind]['rftot']);
    //     this.designList[ind]['rhdif'] = nan(this.rgrnList[ind]['htot']) - nan(this.rgrnList[ind]['rhtot']);

    // }
    this.calcGrandTotal();
  }
  calcTotal1(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    for (let i = 0; i < this.designList.length; i++) {
      //ftotalpcs

      this.designList[ind]["dftot"] =
        nan(this.designList[ind]["df36"]) +
        nan(this.designList[ind]["df38"]) +
        nan(this.designList[ind]["df40"]) +
        nan(this.designList[ind]["df42"]) +
        nan(this.designList[ind]["df44"]) +
        nan(this.designList[ind]["df46"]);

      //htotalpcs
      this.designList[ind]["dhtot"] =
        nan(this.designList[ind]["dh36"]) +
        nan(this.designList[ind]["dh38"]) +
        nan(this.designList[ind]["dh40"]) +
        nan(this.designList[ind]["dh42"]) +
        nan(this.designList[ind]["dh44"]) +
        nan(this.designList[ind]["dh46"]);

      //calccons
      // this.designList[ind]['ravg_cons'] = (nan(this.designList[ind]['mtr']) / (nan(this.designList[ind]['rftot']) + nan(this.designList[ind]['rhtot']))).toFixed(2);
      //  this.designList[ind]['rhavg_cons']= (nan(this.designList[ind]['mtr'])/(nan(this.designList[ind]['rftot'])+nan(this.designList[ind]['rhtot']))).toFixed(2);

      //calcdiff
      //    this.designList[ind]['rfdif'] = nan(this.designList[ind]['ftot']) - nan(this.designList[ind]['rftot']);
      //            this.designList[ind]['rhdif'] = nan(this.rgrnList[ind]['htot']) - nan(this.rgrnList[ind]['rhtot']);
    }
    this.calcdGrandTotal();
  }
  woCalc(ind) {}
  calcGrandTotal() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      f36_tot = 0,
      f38_tot = 0,
      f40_tot = 0,
      f42_tot = 0,
      f44_tot = 0,
      f46_tot = 0,
      h36_tot = 0,
      h38_tot = 0,
      h40_tot = 0,
      h42_tot = 0,
      h44_tot = 0,
      bal_tot = 0,
      h46_tot = 0,
      fdif_tot = 0,
      hdif_tot = 0;
    for (let i = 0; i < this.rgrnList.length; i++) {
      let des = this.rgrnList[i];
      f36_tot += nan(des["rf36"]);
      f38_tot += nan(des["rf38"]);
      f40_tot += nan(des["rf40"]);
      f42_tot += nan(des["rf42"]);
      f44_tot += nan(des["rf44"]);
      f46_tot += nan(des["rf46"]);
      bal_tot += nan(des["rbalmtrs"]);
      h36_tot += nan(des["rh36"]);
      h38_tot += nan(des["rh38"]);
      h40_tot += nan(des["rh40"]);
      h42_tot += nan(des["rh42"]);
      h44_tot += nan(des["rh44"]);
      h46_tot += nan(des["rh46"]);
      fdif_tot += nan(des["rfdif"]);
      hdif_tot += nan(des["rhdif"]);
    }
    this.acdata["rf36_tot"] = f36_tot;
    this.acdata["rf38_tot"] = f38_tot;
    this.acdata["rf40_tot"] = f40_tot;
    this.acdata["rf42_tot"] = f42_tot;
    this.acdata["rf44_tot"] = f44_tot;
    this.acdata["rf46_tot"] = f46_tot;
    this.acdata["rh36_tot"] = h36_tot;
    this.acdata["rh38_tot"] = h38_tot;
    this.acdata["rh40_tot"] = h40_tot;
    this.acdata["rh42_tot"] = h42_tot;
    this.acdata["rh44_tot"] = h44_tot;
    this.acdata["rh46_tot"] = h46_tot;
    this.acdata["bal_tot"] = bal_tot;
    this.acdata["fdif_tot"] = fdif_tot;
    this.acdata["hdif_tot"] = hdif_tot;
    this.acdata["rfs_total"] =
      nan(f36_tot) +
      nan(f38_tot) +
      nan(f40_tot) +
      nan(f42_tot) +
      nan(f44_tot) +
      nan(f46_tot);
    this.acdata["rhs_total"] =
      nan(h36_tot) +
      nan(h38_tot) +
      nan(h40_tot) +
      nan(h42_tot) +
      nan(h44_tot) +
      nan(h46_tot);

    this.acdata["rfh36_tot"] =
      nan(this.acdata["rf36_tot"]) + nan(this.acdata["rh36_tot"]);
    this.acdata["rfh38_tot"] =
      nan(this.acdata["rf38_tot"]) + nan(this.acdata["rh38_tot"]);
    this.acdata["rfh40_tot"] =
      nan(this.acdata["rf40_tot"]) + nan(this.acdata["rh40_tot"]);
    this.acdata["rfh42_tot"] =
      nan(this.acdata["rf42_tot"]) + nan(this.acdata["rh42_tot"]);
    this.acdata["rfh44_tot"] =
      nan(this.acdata["rf44_tot"]) + nan(this.acdata["rh44_tot"]);
    this.acdata["rfh46_tot"] =
      nan(this.acdata["rf46_tot"]) + nan(this.acdata["rh46_tot"]);
    this.acdata["rtot_pcs"] =
      nan(this.acdata["rfs_total"]) + nan(this.acdata["rhs_total"]);
    this.acdata["tot_dif"] =
      nan(this.acdata["fdif_tot"]) + nan(this.acdata["hdif_tot"]);

    this.calcDiff();
  }
  getcolor(shirtdno, shade, ind) {
    let params = {
      shirtdno: shirtdno,
      shade: shade,
    };
    this.rgrnService.getcolor(params).then((res: any) => {
      this.designList[ind].dcolor = res.data[0].color;
    });
  }
  calcdGrandTotal() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      df36_tot = 0,
      df38_tot = 0,
      df40_tot = 0,
      df42_tot = 0,
      df44_tot = 0,
      df46_tot = 0,
      dh36_tot = 0,
      dh38_tot = 0,
      dh40_tot = 0,
      dh42_tot = 0,
      dh44_tot = 0,
      dh46_tot = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      df36_tot += nan(des["df36"]);
      df38_tot += nan(des["df38"]);
      df40_tot += nan(des["df40"]);
      df42_tot += nan(des["df42"]);
      df44_tot += nan(des["df44"]);
      df46_tot += nan(des["df46"]);
      dh36_tot += nan(des["dh36"]);
      dh38_tot += nan(des["dh38"]);
      dh40_tot += nan(des["dh40"]);
      dh42_tot += nan(des["dh42"]);
      dh44_tot += nan(des["dh44"]);
      dh46_tot += nan(des["dh46"]);
    }
    this.acdata["df36_tot"] = df36_tot;
    this.acdata["df38_tot"] = df38_tot;
    this.acdata["df40_tot"] = df40_tot;
    this.acdata["df42_tot"] = df42_tot;
    this.acdata["df44_tot"] = df44_tot;
    this.acdata["df46_tot"] = df46_tot;
    this.acdata["dh36_tot"] = dh36_tot;
    this.acdata["dh38_tot"] = dh38_tot;
    this.acdata["dh40_tot"] = dh40_tot;
    this.acdata["dh42_tot"] = dh42_tot;
    this.acdata["dh44_tot"] = dh44_tot;
    this.acdata["dh46_tot"] = dh46_tot;
    this.acdata["dfs_total"] =
      nan(df36_tot) +
      nan(df38_tot) +
      nan(df40_tot) +
      nan(df42_tot) +
      nan(df44_tot) +
      nan(df46_tot);
    this.acdata["dhs_total"] =
      nan(dh36_tot) +
      nan(dh38_tot) +
      nan(dh40_tot) +
      nan(dh42_tot) +
      nan(dh44_tot) +
      nan(dh46_tot);

    this.acdata["dfh36_tot"] =
      nan(this.acdata["df36_tot"]) + nan(this.acdata["dh36_tot"]);
    this.acdata["dfh38_tot"] =
      nan(this.acdata["df38_tot"]) + nan(this.acdata["dh38_tot"]);
    this.acdata["dfh40_tot"] =
      nan(this.acdata["df40_tot"]) + nan(this.acdata["dh40_tot"]);
    this.acdata["dfh42_tot"] =
      nan(this.acdata["df42_tot"]) + nan(this.acdata["dh42_tot"]);
    this.acdata["dfh44_tot"] =
      nan(this.acdata["df44_tot"]) + nan(this.acdata["dh44_tot"]);
    this.acdata["dfh46_tot"] =
      nan(this.acdata["df46_tot"]) + nan(this.acdata["dh46_tot"]);
    this.acdata["dtot_pcs"] =
      nan(this.acdata["dfs_total"]) + nan(this.acdata["dhs_total"]);

    this.calcDiff();
  }
  calcDiff() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      rtot_dif = 0;
    for (let i = 0; i < this.rgrnList.length; i++) {
      let des = this.rgrnList[i];
      rtot_dif += nan(des["frdif"]) + nan(des["rhdif"]);
    }
    this.acdata["rtot_dif"] = rtot_dif;
    
     //For Handling Save Flag
     this.onsaveDisable = this.acdata.tot_dif > 0 && (this.acdata.tot_dif !=  ((this.acdata.dtot_pcs || 0) + this.canTot))
  }

  calcRate() {
    let item = this.rgrnList;

    let fullrate = 0,
      halfrate = 0,
      totalrate = 0;
    for (let i = 0; i < item.length; i++) {
      fullrate +=
        item[i].rf36 +
        item[i].rf38 +
        item[i].rf40 +
        item[i].rf42 +
        item[i].rf44;
      halfrate +=
        item[i].rh36 +
        item[i].rh38 +
        item[i].rh40 +
        item[i].rh42 +
        item[i].rh44;
      totalrate = fullrate + halfrate;
    }

    this.acdata.fullrate = fullrate;
    this.acdata.halfrate = halfrate;
    this.acdata.totalrate = totalrate;
  }
  // getworkOrder(wo_no){
  //     let params ={
  //         wo_no : wo_no
  //     }
  //     this.rgrnService
  //     .getworkOrder(params)
  //     .then((res: any) => {

  //     });
  // }





  checksetData() {

    if (this.mode != 'Add')
      return

    let rgrnData = [];

    function getSleevData(setSize, rowSize, deletSize, setName, Data, setMaster) {

      rgrnData = JSON.parse(JSON.stringify(Data));
      let filteredSets = setMaster
        .filter(set => set.sleeve === `${setSize}`)
        .sort((a: any, b: any) => a.priority - b.priority);

      let result = [];
      for (let i = 0; i < rgrnData.length; i++) {
        for (let size = 36; size <= 46; size += 2) {
          delete rgrnData[i][`${deletSize}${size}`];
        }
        delete rgrnData[i][`${deletSize}tot`];
      }





      rgrnData.forEach((item: any) => {
        let remainingItem = { ...item };

        filteredSets.forEach(set => {
          let sizes = set.set_combo.split('-').map(Number);
          let minQty = Infinity;

          // Find the minimum quantity among the sizes in the set
          for (let size = sizes[0]; size <= sizes[1]; size += 2) {
            if (remainingItem[`${rowSize}${size}`] < minQty) {
              minQty = remainingItem[`${rowSize}${size}`];
            }
          }

          if (minQty > 0) {
            // let newItem = { ...remainingItem };
            let newItem = {};
            for (let size = sizes[0]; size <= sizes[1]; size += 2) {
              newItem[`${rowSize}${size}`] = minQty;
              remainingItem[`${rowSize}${size}`] -= minQty;
            }
            // Set remaining sizes (not part of the set) to zero
            for (let size = 36; size <= 46; size += 2) {
              if (size < sizes[0] || size > sizes[1]) {
                newItem[`${rowSize}${size}`] = 0;
              }
            }
            newItem['color'] = remainingItem.color;
            newItem['shade'] = remainingItem.shade;
            newItem[`${rowSize}tot`] = minQty * ((sizes[1] - sizes[0]) / 2 + 1);
            newItem[`${setName}_name`] = set.set_combo;
            newItem[`${setName}_id`] = set.set_id;
            newItem[`${setName}_count`] = minQty;
            //Ui Data View Purpose
            newItem[`${setName}_size`] = set.set_combo;
            newItem[`${setName}_sizeQty`] = minQty;
            result.push(newItem);
          }
        });

        // Push remaining quantities
        for (let size = 36; size <= 46; size += 2) {
          if (remainingItem[`${rowSize}${size}`] > 0) {
            let newItem = {};
            newItem['color'] = remainingItem.color;
            newItem['shade'] = remainingItem.shade;
            newItem[`${rowSize}${size}`] = remainingItem[`${rowSize}${size}`];
            newItem[`${rowSize}tot`] = remainingItem[`${rowSize}${size}`];
            newItem[`${setName}_name`] = '';
            newItem[`${setName}_id`] = '';
            newItem[`${setName}_count`] = 0;
            //Ui Data View Purpose
            newItem[`${setName}_size`] = `${size} SIZE`;
            newItem[`${setName}_sizeQty`] = remainingItem[`${rowSize}${size}`];
            // Set all other sizes to zero
            for (let otherSize = 36; otherSize <= 46; otherSize += 2) {
              if (otherSize !== size) {
                newItem[`${rowSize}${otherSize}`] = 0;
              }
            }
            result.push(newItem);
            remainingItem[`${rowSize}${size}`] = 0;
          }
        }
      });
      return result
    }
    this.fullsetData = [];
    this.halfsetData = [];

    this.fullsetData = getSleevData('F/S', 'rf', 'rh', 'fullset', this.rgrnList, this.setmasterData)
    this.halfsetData = getSleevData('H/S', 'rh', 'rf', 'halfset', this.rgrnList, this.setmasterData)

    this.setpcsTot();

  }











  getworkOrder(wono) {
    // this.checksetData();
    if (wono == null) {
      this.acdata.wo_id = "";
      this.acdata.shirt_design = "";
      this.acdata.brand = "";
      this.acdata.style = "";
      this.acdata.fab_design = "";
      this.acdata.sample_no = "";
      this.acdata.wo_date = "";
      this.acdata.width = "";
      this.acdata.age = "";
      this.acdata.rf36_tot = "";
      this.acdata.rf38_tot = "";
      this.acdata.rf40_tot = "";
      this.acdata.rf42_tot = "";
      this.acdata.rf44_tot = "";
      this.acdata.rf46_tot = "";
      this.acdata.rh36_tot = "";
      this.acdata.rh38_tot = "";
      this.acdata.rh40_tot = "";
      this.acdata.rh42_tot = "";
      this.acdata.rh44_tot = "";
      this.acdata.rh46_tot = "";
      this.acdata.rfh36_tot = "";
      this.acdata.rfh38_tot = "";
      this.acdata.rfh40_tot = "";
      this.acdata.rfh42_tot = "";
      this.acdata.rfh44_tot = "";
      this.acdata.rfh46_tot = "";
      this.acdata.rfh46_tot = "";
      this.acdata.rfs_total = "";
      this.acdata.rhs_total = "";
      this.acdata.rtot_pcs = "";
      this.acdata.rtot_diff = "";
      this.acdata.f36_tot = "";
      this.acdata.f38_tot = "";
      this.acdata.f40_tot = "";
      this.acdata.f42_tot = "";
      this.acdata.f44_tot = "";
      this.acdata.f46_tot = "";
      this.acdata.h36_tot = "";
      this.acdata.h38_tot = "";
      this.acdata.h40_tot = "";
      this.acdata.h42_tot = "";
      this.acdata.h44_tot = "";
      this.acdata.h46_tot = "";
      this.acdata.fh36_tot = "";
      this.acdata.fh38_tot = "";
      this.acdata.fh40_tot = "";
      this.acdata.fh42_tot = "";
      this.acdata.fh44_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fs_total = "";
      this.acdata.hs_total = "";
      this.acdata.tot_pcs = "";
      this.rgrnList = [
        {
          shirt_design_no: "",
          shade: "",
          rf36: 0,
          rf38: 0,
          rf40: 0,
          rf42: 0,
          rf44: 0,
          rf46: 0,
          rh36: 0,
          rh38: 0,
          rh40: 0,
          rh42: 0,
          rh44: 0,
          rh46: 0,
          rtotmtrs: 0,
          rfdif: 0,
          rhdif: 0,
          rbalmtrs: 0,
        },
      ];
    } else {
      let params = {
        wo_no: wono,
      };

      let that = this;
      that.rgrnService.getworkOrder(params).then((res: any) => {
        if (res.success == "false") {
          this.acdata.wo_no = null;
          $("#wo_no").focus();
          swal("PLEASE UPLOAD DESIGN PHOTO FIRST...");
          return false;
        }else if(res.success == 'R&D NOT APPROVED'){
          this.acdata.wo_no = null;
          $("#wo_no").focus();
          swal("R&D NOT APPROVED");
          return false;
        }else if(res.success == 'COST SAMPLE'){
          this.acdata.wo_no = null;
          $("#wo_no").focus();
          swal("PLEASE GENERATE MRP IN COST SAMPLE");
          return false;
        }
         else {
          if (res.data == false) {
            this.acdata.wo_id = "";
            this.acdata.ac_id = "";
            this.acdata.cu_no = "";
            this.acdata.fit = "";
            this.acdata.shirt_design_no = "";
            this.acdata.brand = "";
            this.acdata.style = "";
            this.acdata.fab_no = "";
            this.acdata.wo_date = "";
            this.acdata.mrp = "";
            this.acdata.type = "";
            this.acdata.sample_no = "";
            this.acdata.wo_date = "";
            this.acdata.brand = "";
            this.acdata.age = "";
            this.acdata.rf36_tot = "";
            this.acdata.rf38_tot = "";
            this.acdata.rf40_tot = "";
            this.acdata.rf42_tot = "";
            this.acdata.rf44_tot = "";
            this.acdata.rf46_tot = "";
            this.acdata.rh36_tot = "";
            this.acdata.rh38_tot = "";
            this.acdata.rh40_tot = "";
            this.acdata.rh42_tot = "";
            this.acdata.rh44_tot = "";
            this.acdata.rh46_tot = "";
            this.acdata.rfh36_tot = "";
            this.acdata.rfh38_tot = "";
            this.acdata.rfh40_tot = "";
            this.acdata.rfh42_tot = "";
            this.acdata.rfh44_tot = "";
            this.acdata.rfh46_tot = "";
            this.acdata.rfh46_tot = "";
            this.acdata.rfs_total = "";
            this.acdata.rhs_total = "";
            this.acdata.rtot_pcs = "";
            this.acdata.rtot_diff = "";
            this.acdata.df36_tot = 0;
            this.acdata.df38_tot = 0;
            this.acdata.df40_tot = 0;
            this.acdata.df42_tot = 0;
            this.acdata.df44_tot = 0;
            this.acdata.df46_tot = 0;
            this.acdata.dh36_tot = 0;
            this.acdata.dh38_tot = 0;
            this.acdata.dh40_tot = 0;
            this.acdata.dh42_tot = 0;
            this.acdata.dh44_tot = 0;
            this.acdata.dh46_tot = 0;
            this.acdata.dfh36_tot = 0;
            this.acdata.dfh38_tot = 0;
            this.acdata.dfh40_tot = 0;
            this.acdata.dfh42_tot = 0;
            this.acdata.dfh44_tot = 0;
            this.acdata.dfh46_tot = 0;
            this.acdata.dfh46_tot = 0;
            this.acdata.dfs_total = 0;
            this.acdata.dhs_total = 0;
            this.acdata.dtot_pcs = 0;
            this.acdata.dtot_diff = 0;
            this.acdata.f36_tot = "";
            this.acdata.f38_tot = "";
            this.acdata.f40_tot = "";
            this.acdata.f42_tot = "";
            this.acdata.f44_tot = "";
            this.acdata.f46_tot = "";
            this.acdata.h36_tot = "";
            this.acdata.h38_tot = "";
            this.acdata.h40_tot = "";
            this.acdata.h42_tot = "";
            this.acdata.h44_tot = "";
            this.acdata.h46_tot = "";
            this.acdata.fh36_tot = "";
            this.acdata.fh38_tot = "";
            this.acdata.fh40_tot = "";
            this.acdata.fh42_tot = "";
            this.acdata.fh44_tot = "";
            this.acdata.fh46_tot = "";
            this.acdata.fh46_tot = "";
            this.acdata.fs_total = "";
            this.acdata.hs_total = "";
            this.acdata.tot_pcs = "";
            this.acdata.bal_tot = "";
            this.rgrnList = [
              {
                shirt_design_no: "",
                shade: "",
                rf36: 0,
                rf38: 0,
                rf40: 0,
                rf42: 0,
                rf44: 0,
                rf46: 0,
                rh36: 0,
                rh38: 0,
                rh40: 0,
                rh42: 0,
                rh44: 0,
                rh46: 0,
                rtotmtrs: 0,
                rfdif: 0,
                rhdif: 0,
                rbalmtrs: 0,
              },
            ];
          } else {

            let params = {
              design_no: res.list[0].shirt_design_no,
            };
            this.rgrnService.getdesignMastercombo(params).then((res: any) => {
              that.designPreview = res.data; 
            
              if (that.designPreview.length > 0) {
                $("#designpr").modal("show");
                 that.acdata.wsp_full = res.data[0].fsrate;
                 that.acdata.wsp_half = res.data[0].hsrate;
                 that.acdata.mrp = res.data[0].mrp
                //For check current design is running design(Number format)
                if (!isNaN(res.data[0].design_no))
                  that.isNewDesign = 'true';
              }
              else {
                swal("Given design not Matched In Master!!")

                return false;
              }
              
            });
            
            that.acdata.wo_id = res.data[0].wo_id;
            that.acdata.ac_id = res.data[0].ac_id;
            that.acdata.shirt_design_no = res.data[0].shirt_design_no;
            that.acdata.cu_no = res.data[0].cu_no;
            that.acdata.style = res.data[0].style;
            that.acdata.mrp = res.data[0].mrp;
            that.acdata.fab_no = res.data[0].fab_design_no;
            that.acdata.sample_no = res.data[0].sample_no;
            that.acdata.wo_date = res.data[0].wo_date;
            //   that.acdata.date = res.date;
            that.acdata.brand = res.data[0].brand;
            that.acdata.brand = res.data[0].brand;
            that.acdata.fit = res.data[0].fit;
            that.acdata.type = res.data[0].cost_sam_type;
            that.acdata.fh36_tot = res.data[0].fh36_tot;
            that.acdata.fh38_tot = res.data[0].fh38_tot;
            that.acdata.fh40_tot = res.data[0].fh40_tot;
            that.acdata.fh42_tot = res.data[0].fh42_tot;
            that.acdata.fh44_tot = res.data[0].fh44_tot;
            that.acdata.fh46_tot = res.data[0].fh46_tot;
            that.acdata.fs_total = res.data[0].fs_total;
            that.acdata.hs_total = res.data[0].hs_total;
            that.acdata.tot_pcs = res.data[0].tot_pcs;
            let wodate: any = new Date(res.data[0].wo_date);
            let date: any = new Date(that.acdata.date);
            //     that.acdata.age = res.data[0].wo_date-that.acdata.date;
            that.acdata.age = (date - wodate) / (1000 * 60 * 60 * 24);
            that.rgrnList;
            that.rgrnList = res.list;
            if (res.damageList && res.damageList.length > 0) {
              that.designList = res.damageList;
              that.calcdGrandTotal();
            }
        that.tempData = res.list;
            that.shadeList = res.shade;
            let f36_tot = 0,
              f38_tot = 0,
              f40_tot = 0,
              f42_tot = 0,
              f44_tot = 0,
              f46_tot = 0,
              h36_tot = 0,
              h38_tot = 0,
              h40_tot = 0,
              h42_tot = 0,
              h44_tot = 0,
              h46_tot = 0;
            for (let i = 0; i < res.list.length; i++) {
              let des = res.list[i];
              f36_tot += des.f36;
              f38_tot += des.f38;
              f40_tot += des.f40;
              f42_tot += des.f42;
              f44_tot += des.f44;
              f46_tot += des.f46;
              h36_tot += des.h36;
              h38_tot += des.h38;
              h40_tot += des.h40;
              h42_tot += des.h42;
              h44_tot += des.h44;
              h46_tot += des.h46;


              
              // this.rgrnList[i].rf36 = 0;
              // this.rgrnList[i].rf38 = 0;
              // this.rgrnList[i].rf40 = 0;
              // this.rgrnList[i].rf42 = 0;
              // this.rgrnList[i].rf44 = 0;
              // this.rgrnList[i].rf46 = 0;
              // this.rgrnList[i].rh36 = 0;
              // this.rgrnList[i].rh38 = 0;
              // this.rgrnList[i].rh40 = 0;
              // this.rgrnList[i].rh42 = 0;
              // this.rgrnList[i].rh44 = 0;
              // this.rgrnList[i].rh46 = 0;
              this.rgrnList[i].rbalmtrs = 0;
              
              this.calcTotal(i);
            }
            this.acdata["f36_tot"] = f36_tot;
            this.acdata["f38_tot"] = f38_tot;
            this.acdata["f40_tot"] = f40_tot;
            this.acdata["f42_tot"] = f42_tot;
            this.acdata["f44_tot"] = f44_tot;
            this.acdata["f46_tot"] = f46_tot;
            this.acdata["h36_tot"] = h36_tot;
            this.acdata["h38_tot"] = h38_tot;
            this.acdata["h40_tot"] = h40_tot;
            this.acdata["h42_tot"] = h42_tot;
            this.acdata["h44_tot"] = h44_tot;
            this.acdata["h46_tot"] = h46_tot;
          }
        }
      });
    }
  }
  closedesign(){
    this.acdata.desid = this.designPreview[0].des_id;
    let result = this.tempData.filter(o1 => !this.designPreview.some(o2 => o1.color === o2.color));
    if(result.length > 0){
  
      swal("ERROR", "<h2>Color Not Matched With design Master!!<h2>", "error")
      this.acdata.wo_no = null;
      return false;
    }
    else{
    $("#designpr").modal("hide"); 
    }

 
  }

  
  getpartyname(code) {
    let params = {
      code: code,
    };
    this.rgrnService.getPartyDet(params).then((res: any) => {
      this.acdata.party_name = res.data[0].party_name;
      this.acdata.party_id = res.data[0].party_id;
    });
  }
  // calcDiff(){
  //     let nan = function(no) {
  //         if(no=='' || no==null){
  //          return 0;
  //         }
  //      if(isNaN(no)) {
  //          return 0;
  //      }
  //      return parseFloat(no+'');
  //     },
  //     ac_tot_diff = 0;
  //     for(let i=0;i<this.rgrnList.length;i++){
  //         let rgrn = this.rgrnList[i];
  //         ac_tot_diff += nan(rgrn['r'])+nan(rgrn['ac_hs_diff']);
  //     }
  //     this.acdata['ac_tot_diff'] = ac_tot_diff;
  // }
  getrgrnList(rgrn_id) {
    let params = {
      rgrn_id: rgrn_id,
    };
    this.rgrnService.getEditDesignList(params).then((res: any) => {
      if (res.acdata) {
        this.acdata = res.acdata;
      }
      this.shadeList = res.shade;
         this.fullsetData = res.fullsetData;
         this.halfsetData = res.halfsetData
        //  this.setpcsTot();
      this.cancelList = res.canceldata;
      if (res.canceldata.length == 0) {
        this.cancelList = [
          {
            shade: "",
            color: "",
            slv: "",
            size: "",
            qty: "",
          },
        ];
      }
      //    this.acdata.df36_tot = res.acdata.df36_tot;
      for (let i = 0; i < res.data.length; i++) {
        this.rgrnList[i] = res.data[i];
        // this.calcTotal('$event',i);
        //    this.calcGrandTotal();
        //     this.calcdGrandTotal();
      }
      for (let i = 0; i < res.detdata.length; i++) {
        this.rgrnList[i] = Object.assign({}, this.rgrnList[i], res.detdata[i]);
      }
      for (let i = 0; i < res.wodata.length; i++) {
        this.designList[i] = res.wodata[i];

        // this.calcTotal('$event',i);
        //    this.calcGrandTotal();
        //     this.calcdGrandTotal();
      }
      this.setpcsTot();
    });
  }

  isRowEmpty(ind) {
    let data = this.data.rgrnList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.rgrnList.length > 1) {
          that.data.rgrnList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
        //    that.calcTotal($event,ind);
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  getStickerData() {
    let params = {};
    this.rgrnService.getStickerData(params).then((res: any) => {
      this.printSticker(res);
    });
  }
  printSticker(res) {
    let params = res.data;

    this.rgrnService.printSticker(params).then((res: any) => {});
  }
  print() {
    // if(box_print == 'BOX'){
    //     this.noofpcs = 2;
    // }else if(box_print == 'SHIRT'){
    //     this.noofpcs = 1;
    // }
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      export: this.export,
      box: this.box,
      shirt: this.shirt,
      designdet: JSON.stringify(this.res1.printData),
    };
    this.saleDC.print(params).then((res: any) => {});
    if (this.mode == "Add") {
      let tabObj = {
        action: "CloseTab",
        params: {},
      };

      this.tabUpdateEvent.emit(tabObj);
    } else {
      let tabObj = {
        action: "CloseTab",
        params: {},
      };
      this.tabUpdateEvent.emit(tabObj);
    }
  }

  closeModal() {
    if (this.mode == "Add") {
      let tabObj = {
        action: "CloseTab",
        params: {},
      };

      this.tabUpdateEvent.emit(tabObj);
    } else {
      let tabObj = {
        action: "CloseTab",
        params: {},
      };
      this.tabUpdateEvent.emit(tabObj);
    }
  }
  getAuto() {
    this.rgrnService.getAuto({}).then((res: any) => {
      this.acdata.ref_no = res;
    });
  }
  getsetDet(){
       this.woservice.getSetDetails({}).then((res: any)=>{
       
        this.setmasterData = res.data
       })
  }
  getDesignDetailsList(wono) {
    if (wono == null) {
      this.acdata.wo_id = "";
      this.acdata.shirtdno = "";
      this.acdata.brand = "";
      this.acdata.style = "";
    } else {
      let params = {
        wo_no: wono,
      };

      let that = this;
      that.rgrnService.getDesignDetailsList(params).then((res: any) => {
        that.acdata.wo_id = res.data[0].wo_id;
        that.acdata.shirtdno = res.data[0].shirtdno;
        that.acdata.brand = res.data[0].brand;
        that.acdata.style = res.data[0].style;
      });
    }
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.rgrnList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }
   onShowsetDet(){
     this.setShow = !this.setShow;
   }

  onNextClick() {
    if (this.mode === 'View') {
      this.onShowsetDet();
      return;
    }

    const style = this.acdata.style;
    if (style === 'RR FORMAL' || style === 'RR CASUAL') {
      const that = this;
      swal({
        title: 'Choose Action',
        html: `Variety: <b>${this.acdata.type || ''}</b>`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Set Mapping',
        cancelButtonText: 'Just Save',
      }).then(function () {
        that.onShowsetDet();
        that.checksetData();
      }, function (dismiss) {
        if (dismiss === 'cancel') {
          that.oncheckemptyrow();
        }
      });
    } else {
      this.onShowsetDet();
      this.checksetData();
    }
  }
  oncheckemptyrow() {
 
    if (this.acdata.approval == null || this.acdata.rgrn_no == 0) {
      swal("Make sure that all the details are given!! ");
    } else {
      let design = this.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].dshade != "") {
          design[i].design_no = this.rgrnList[0].shirt_design_no;
          desList.push(design[i]);
        }
      }
      this.designList = desList;

      let design1 = this.rgrnList;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].shade != "") {
          desList1.push(design1[i]);
        }
      }
      this.rgrnList = desList1;
      let design2 = this.cancelList;
      let desList2 = [];
      for (let i = 0; i < design2.length; i++) {
        if (design2[i].shade != "") {
          desList2.push(design2[i]);
        }
      }

      this.cancelList = desList2;
      this.onSaveOrder();
    }
  }

  onSaveOrder(): void {
    
    if (!this.acdata.wo_no || this.acdata.cu_no == undefined) {
      swal("Make sure that all the details are given!! ");
    }
    else if(!this.acdata.desid){
   swal("ERROR", "<h2>SomeThing Went Wrong From design Master!!<h2>", "error");
    }
    
    else {
      this.onsaveDisable = true;
      let params: any = Object.assign({}, this.acdata);
      params["tabevent"] = undefined;
      params["isNewDesign"] = this.isNewDesign;
      params["data"] = JSON.stringify(this.designList);
      params["wodata"] = JSON.stringify(this.rgrnList);
      params["cancelData"] = JSON.stringify(this.cancelList);
      params["fsData"] = JSON.stringify(this.fullsetData);
      params["hsData"] = JSON.stringify(this.halfsetData);
      params["ac_date"] = this.datePipe.transform(
        params["ac_date"],
        "yyyy-MM-dd"
      );
     
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this RGRN Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.isLoadMask = that.rgrnService
          .saveOrder(params)
          .then(function (res: any) {
            that.onsaveDisable = true;
            that.isLoading = true;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }

            if (res.success) {
              that.res1 = res;
              that.printPreview = res.printData;
              $("#printpr").modal("show");

              // that.print(res);
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.onsaveDisable = false;
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      }).catch(function (error: any){
        that.onsaveDisable = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/rgrn/addEditRgrn.ts